import { FC } from 'react';
import { MessageState } from './message-state.types';
import { Icons } from 'assets';

export const IconVariants: Record<MessageState, FC> = {
  read: Icons.MessageRead,
  unread: Icons.MessageUnread,
};
